export const loyaltyRestrictedMerchants = [
  "test",
  // "1627486427365066315", // test-lot10
  // "test-lot10",
  // "1680079833779175922", // lot10hutong
  // "lot10hutong"
];
